<button class="syn-close-dialog" mat-icon-button (click)="cancel()">
    <mat-icon svgIcon="close"></mat-icon>
</button>

<h2 mat-dialog-title>
    Créer un nouveau groupe
</h2>

<mat-dialog-content>
    <mat-form-field fxFlexFill appearance="outline">
        <mat-label>Nom du groupe</mat-label>
        <input matInput #input [maxlength]="MAX_GROUP_LENGTH" [formControl]="groupFormControl" placeholder="Nom du groupe" autocomplete="off">
        <mat-hint align="end">{{ groupFormControl.value?.length || 0 }}/{{ MAX_GROUP_LENGTH }}</mat-hint>
    </mat-form-field>

    <syn-message-box *ngIf="groupFormControl.status === 'INVALID'" color="info" leftIcon="information-outline">
        Pour être valide il faut que le nom:
        <ul>
            <li>Commence et se termine par un caractère alphanumérique.</li>
            <li>Possède une taille comprise entre {{ MIN_GROUP_LENGTH }} et {{ MAX_GROUP_LENGTH }} caractères.</li>
        </ul>
    </syn-message-box>
</mat-dialog-content>

<div mat-dialog-actions fxLayout="row" fxLayoutAlign="flex-end" fxLayoutGap="5px">
    <button mat-button (click)="cancel()">Annuler</button>
    <button mat-button [disabled]="groupFormControl.status === 'INVALID'" color="primary" (click)="confirm()">Créer</button>
</div>
